import React from "react";
import { Dialog, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{
        fontFamily: "PoppinsRegular",
        fontSize: "1.5rem",
        textAlign: "center",
        color: "#3c3c3c",
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const DialogComponent = (props) => {
  return (
    <Dialog
      className="weekly-stats-dialogue"
      open={props.dialogOpen}
      onClose={() => {
        props.handleDialogOpen(false);
      }}
      PaperProps={{
        style: { borderRadius: 20, backgroundColor: "#e3fff5" },
      }}
      fullWidth
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={() => {
          props.handleDialogOpen(false);
        }}
      >
        {props.title}
      </BootstrapDialogTitle>

      {props.children}
    </Dialog>
  );
};

DialogComponent.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  handleDialogOpen: PropTypes.func,
  dialogOpen: PropTypes.bool,
};

DialogComponent.defaultProps = {
  title: "",
  handleDialogOpen: () => {},
  dialogOpen: false,
  children: () => {},
};

export default DialogComponent;
